import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import fr from 'facet-rest';
import React, { useEffect } from 'react';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  ScenarioSelectionRedefinedPreviewScenariosContainer,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ScenarioSelectionRedefinedPreviewScenarios/ScenarioSelectionRedefinedPreviewScenariosContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';


export const FacetPlanProposalScenarioSelectionIntroPageLayout = ({ onAgentReview }) => {
  const { loadModalCollectionByLink } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { resource } = useMetaLayoutContext();

  const proposalExpirationRel = resource.withRelationship(
    fr.relationships.proposalExpiration.name,
    (rel) => rel,
    () => null,
  );

  useEffect(() => {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.navigateTo, 'Navigated to Scenario Selection Intro Page');
  }, []);

  useEffect(() => {
    if (proposalExpirationRel) {
      loadModalCollectionByLink(proposalExpirationRel.link('related').url());
    }
  }, [proposalExpirationRel]);

  useComponentDidMount(() => {
    resource.withRelationship(
      fr.relationships.markProposalViewed.name,
      async (rel) => {
        const [resourceToSubmit] = await rel.link('related').get();
        await resourceToSubmit.submit();
      },
      () => null,
    );
  });

  const onSelectSuccess = async (scenarioPreviewResource) => {
    // After we submit the scenario successfully we need to make sure we get taken into the scenario wizard.
    // We will take you to the decision step which will then direct you to the correct place
    await scenarioPreviewResource.withRelationship(fr.relationships.scenarioSelectionDecisionStep.name,
      (decisionStepRel) => loadPageContentLink(decisionStepRel.link('related')),
      () => null);
  };

  return (
    <ScenarioSelectionRedefinedPreviewScenariosContainer onAgentReview={onAgentReview} onSelectSuccess={onSelectSuccess} />
  );
};

FacetPlanProposalScenarioSelectionIntroPageLayout.defaultProps = {
  onAgentReview: noop,
};

FacetPlanProposalScenarioSelectionIntroPageLayout.propTypes = {
  onAgentReview: PropTypes.func,
};
